<template>
	<div class="toast-wrapper">
		<v-dialog v-model="dialog" width="500" transition="slide-y-transition" rounded>
			<div class="success-modal-wrapper">
				<div class="raport-img-modal">
					<img src="@/assets/svg/raporto-icon.svg" />
				</div>
				<div class="raport-success-text">{{ getStateWithParam(message) }}</div>

				<div class="btn-thnx-modal-wrapper">
					<button class="btn-thnx-modal" @click="goRaportPage()">
						<v-icon color="green">done</v-icon>
					</button>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'BaseToastModal',
	props: {
		message: {
			type: [String],
		},
	},
	data() {
		return {
			dialog: true,
		};
	},
	methods: {
		goRaportPage() {
			this.dialog = !this.dialog;
			this.$router.push({
				name: 'report_label',
				path: '/report',
			});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss" scoped>
.success-modal-wrapper {
	padding: 16px;
	background-color: white;
	border-radius: 15px;
	.raport-img-modal {
		height: 320px;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			max-width: 100%;
			height: auto;
		}
	}

	.raport-success-text {
		display: flex;
		justify-content: center;
		font-size: 18px;
		font-weight: 700;
	}

	.btn-thnx-modal-wrapper {
		padding-top: 20px;
		display: flex;
		justify-content: center;
		.v-icon {
			font-size: 70px;
			&:focus {
				outline: none;
			}
		}
	}
}
</style>
